import { createSelector, createSlice } from "@reduxjs/toolkit";
import { p2pSettings as initialState } from "../initialState";
import {
    selectAllowSubRegistrantToChangeRegRoleBasedOnEnabledTeamsSelector,
    selectBaseUrlSelector,
    selectRegistrationFeeDisplaySettingsSelector,
} from "../selectors/p2pSettingsSelectors/p2pSettingsSelectors";

export const slice = createSlice({
    name: "p2pSettings",
    initialState,
    reducers: {},
});

// selectors

// Same as getP2PSettings
export const selectAllP2pSettings = (state) => state.p2pSettings;

export const selectAlias = (state) => state.p2pSettings.alias;

export const selectBaseUrl = (state) => selectBaseUrlSelector(state);

export const selectAllowSubRegistrantToChangeRegRoleBasedOnEnabledTeams = (
    state,
) => selectAllowSubRegistrantToChangeRegRoleBasedOnEnabledTeamsSelector(state);

export const selectRegistrationFeeDisplaySettings = createSelector(
    [(state) => selectAllP2pSettings(state)],
    (p2pSettings) => selectRegistrationFeeDisplaySettingsSelector(p2pSettings),
);

export default slice.reducer;
